export enum PortfolioActives {
  TotalPortfolio = 1,
  TotalAssets = 2,
  TotalContemplatedAssets = 3,
  AssetsContemplatedWithAssetsDelivered = 4,
  AssetsContemplatedWithAssetsToBeDelivered = 5,
  AssetsNotContemplated = 6,
  TotalCancelledAssets = 7,
  CancelledWith1InstallmentPaid = 8,
  ContemplationsInTheMonth = 9,
  ContemplatedAssetsUpToDateWithoutTheAsset = 10,
  ContemplatedAssetsUpToDateWithTheAsset = 11,
  ContemplatedInArrearsWithoutTheAsset = 12,
  ContemplatedInArrearsWithTheAsset = 13,
  NotContemplatedUpToDate = 14,
  NotContemplatedInArrears = 15,
  TenPercentOrLessLeftToPayForAsset = 16,
  PaidOff = 17,
  CanceledWithdrawals = 18,
  AwaitingIssuanceNF = 19
}
